import { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

const getValue = (val) =>
  val && (val === 'auto' ? 'auto' : `${val}px !important`);

const sizes = css`
  padding: ${(props) => getValue(props.p)};
  padding-top: ${(props) => getValue(props.pt)};
  padding-bottom: ${(props) => getValue(props.pb)};
  padding-right: ${(props) => getValue(props.pr)};
  padding-left: ${(props) => getValue(props.pl)};
  margin: ${(props) => getValue(props.m)};
  margin-top: ${(props) => getValue(props.mt)};
  margin-bottom: ${(props) => getValue(props.mb)};
  margin-right: ${(props) => getValue(props.mr)};
  margin-left: ${(props) => getValue(props.ml)};
  ${ifProp(
    'mx',
    css`
      margin-left: ${prop('mx')};
      margin-right: ${prop('mx')};
    `
  )}
  ${ifProp(
    'my',
    css`
      margin-top: ${prop('my')};
      margin-bottom: ${prop('my')};
    `
  )}
  ${ifProp(
    'px',
    css`
      padding-left: ${prop('px')};
      padding-right: ${prop('px')};
    `
  )}
  ${ifProp(
    'py',
    css`
      padding-top: ${prop('py')};
      padding-bottom: ${prop('py')};
    `
  )}
`;

export default sizes;
